<ng-container>
  <app-header></app-header>
  <main style="height: calc(100% - 64px);overflow: auto;">

    <div class="app-content">
      <router-outlet></router-outlet>
    </div>

  </main>
</ng-container>
